
import React, { useEffect, useRef } from 'react';
import { ContextMenuItem } from '../../types';

interface ContextMenuProps {
  x: number;
  y: number;
  items: ContextMenuItem[];
  onClose: () => void;
}

const ContextMenu: React.FC<ContextMenuProps> = ({ x, y, items, onClose }) => {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <div 
        ref={menuRef}
        className="fixed z-[1000] bg-white rounded-lg shadow-xl border border-slate-200 min-w-[180px] py-1.5 animate-in fade-in zoom-in-95 duration-100"
        style={{ top: y, left: x }}
    >
      {items.map((item) => (
        <React.Fragment key={item.label}>
          <button
            onClick={() => {
              if (!item.disabled) {
                  item.onClick();
                  onClose();
              }
            }}
            disabled={item.disabled}
            className={`w-full text-left px-3 py-2 text-xs font-medium flex items-center gap-2 transition-colors
              ${item.danger 
                  ? 'text-red-600 hover:bg-red-50' 
                  : 'text-slate-700 hover:bg-slate-100'
              }
              ${item.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
            `}
          >
            {item.icon && <span className="w-4 h-4 flex items-center justify-center">{item.icon}</span>}
            {item.label}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};

export default ContextMenu;
